import { config } from '~app/config';

import {
  isHttpError,
  isTimeoutError,
} from '@breezeventures/web-lib-ph-request/errors';
import { makeRequest } from '@breezeventures/web-lib-ph-request/make-request';
import { ResponseSuccess } from '@breezeventures/web-lib-ph-request/types';
import { useMutation } from '@tanstack/react-query';

import { FileUploadPayload, FileUploadResponse } from './file-upload-api';

import { isFileValidationCode } from '../lib';
import { FileUploadError } from '../lib/file-validation-error';

export type UploadOcrImageParams = FileUploadPayload & {
  signal?: AbortSignal;
};

export function useUploadOcrImage() {
  return useMutation({
    mutationFn: ({ fileItem, applicationId, signal }: UploadOcrImageParams) => {
      const formData = new FormData();
      formData.append(
        'frontImage',
        fileItem.frontImage,
        fileItem.frontImage.name
      );
      formData.append(
        'data',
        JSON.stringify({
          applicationId,
          docType: fileItem.docType,
          waitForResponse: true,
        })
      );

      return makeRequest<ResponseSuccess<FileUploadResponse>>({
        type: 'multipart/form-data',
        url: `${config.apiHost}/kyc/api/v1/kyc/images/upload_ocr_image`,
        credentials: 'include',
        timeout: 60 * 1000,
        cache: false,
        payload: formData,
        signal,
      })
        .then((res) => res.payload)
        .catch((err: Error) => {
          if (isHttpError(err) && isFileValidationCode(err.code)) {
            throw new FileUploadError({
              status: err.status,
              code: err.code,
            });
          }
          throw err;
        });
    },
    retry: (attemptsCount, error) => {
      return attemptsCount < 3 && isTimeoutError(error);
    },
  });
}
